// extracted by mini-css-extract-plugin
export default {"text":"WidgetPreview--text--7ce801","preview":"WidgetPreview--preview--423736","tooltipWrapper":"WidgetPreview--tooltipWrapper--1e7231"};